import { ArrowRight } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";

const ArticleCaseCta = () => {
  const { t, lang } = useLanguage();

  return (
    <aside className="mt-16 flex justify-center">
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-carbon text-carbon-foreground shadow-2xl">
        <div className="flex flex-col items-stretch">
          {/* Decorative accent line */}
          <div className="h-1.5 w-full shrink-0 bg-primary" />

          <div className="flex flex-col items-center gap-6 p-6 md:p-8">
            {/* Text content */}
            <div className="space-y-3 text-center">
              <div>
                <h3 className="mb-1 font-body text-[10px] font-bold uppercase tracking-widest text-primary">
                  {t("articleCaseCta", "label")}
                </h3>
                <h2 className="font-display text-xl font-bold leading-tight text-carbon-foreground md:text-2xl">
                  {t("articleCaseCta", "title")}
                </h2>
              </div>
              <p className="mx-auto max-w-sm font-body text-sm text-carbon-foreground/80">
                {t("articleCaseCta", "intro")}{" "}
                <strong className="font-semibold text-carbon-foreground">
                  {t("articleCaseCta", "highlight")}
                </strong>
                .
              </p>
            </div>

            {/* CTA */}
            <div className="w-full">
              <Button
                asChild
                size="lg"
                className="h-11 w-full rounded-xl bg-primary px-6 font-body text-sm font-bold uppercase tracking-wider text-primary-foreground transition-transform hover:scale-105 active:scale-95"
              >
                <Link to={lang === "es" ? "/casos-reales" : "/en/real-cases"}>
                  {t("articleCaseCta", "cta")}
                  <ArrowRight className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ArticleCaseCta;
